import { render, staticRenderFns } from "./WithdrawList.vue?vue&type=template&id=517438d3&scoped=true&"
import script from "./WithdrawList.vue?vue&type=script&lang=js&"
export * from "./WithdrawList.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawList.vue?vue&type=style&index=0&id=517438d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517438d3",
  null
  
)

export default component.exports